import { useContext } from "react";
import { Table } from '../../../components/table/Table';
import Loader from "../../../components/loader/Loader";
import { FeatureContext } from "../../../Context";
import { lang } from "../../../Utils";
import Filters from "./Filters";
import Chips from "./Chips";
import Actions from "./Actions";
import Charts from "./Charts";

const Orders = () => {

  const context = useContext(FeatureContext);

  const onRowClick = (value) => {
    if (!!value.toDetail) {
      window.location.href = value.toDetail;
    }
  }

  if (context.loading) {
    return <Loader />
  } else {
    return <div>
      <Actions />
      {(context.showFilters) ? <Filters /> : <Chips />}
      {(context.showCharts) ? <Charts /> : null}
      <Table
        dataloading={context.dataloading}
        dataSet={context?.orders?.data} pagination={true}>
        <Table.Caption>{lang('Orders List')}</Table.Caption>
        <Table.Header>
          <Table.Header.Column sortKey={"salesOrderNumber"} sortable={true}>{lang('Bonfiglioli Order')}</Table.Header.Column>
          <Table.Header.Column sortKey={"purchaseOrderNumber"} sortable={true}>{lang('Customer Order')}</Table.Header.Column>
          <Table.Header.Column sortKey={"orderDate"} sortable={true}>{lang('Order Date')}</Table.Header.Column>
          <Table.Header.Column sortKey={"netValue"} sortable={true}>{lang('Price')}</Table.Header.Column>
          <Table.Header.Column sortKey={"status.value"} sortable={true}>{lang('Status')}</Table.Header.Column>
          <Table.Header.Column sortKey={"shipTo"} sortable={true}>{lang('Ship to')}</Table.Header.Column>
        </Table.Header>
        <Table.Body noDataMessage={lang('No Data available to display')}>
          <Table.Body.Text onClick={onRowClick} label={lang('Bonfiglioli Order')} field="salesOrderNumber" />
          <Table.Body.Text onClick={onRowClick} label={lang('Customer Order')} field="purchaseOrderNumber" />
          <Table.Body.Date onClick={onRowClick} label={lang('Order Date')} field="orderDate" />
          <Table.Body.Currency onClick={onRowClick} label={lang('Price')} field="netValue" currency="currency" />
          <Table.Body.Status onClick={onRowClick} label={lang('Status')} field="status.value" code="status.code" />
          <Table.Body.Text onClick={onRowClick} label={lang('Ship to')} field="shipTo" />
        </Table.Body>
      </Table>

    </div>
  }

}

export default Orders;